{
  "name": "flowwwme",
  "version": "2.40.0",
  "author": "Flowww development team",
  "homepage": "https://www.flowww.net/",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "test": "ng test",
    "lint": "ng lint",
    "e2e": "ng e2e",
    "cap:add:ios": "node scripts/setup-ios.js",
    "cap:sync": "npx cap sync && npm run fix:ios-version",
    "cap:sync:ios": "npx cap sync ios && npm run fix:ios-version",
    "fix:ios-version": "node scripts/fix-ios-version.js"
  },
  "private": true,
  "dependencies": {
    "@angular/common": "20.1.4",
    "@angular/core": "20.1.4",
    "@angular/forms": "20.1.4",
    "@angular/platform-browser": "20.1.4",
    "@angular/platform-browser-dynamic": "20.1.4",
    "@angular/router": "20.1.4",
    "@capacitor-community/speech-recognition": "^7.0.0",
    "@capacitor/android": "^7.0.0",
    "@capacitor/app": "^7.0.0",
    "@capacitor/browser": "^7.0.0",
    "@capacitor/camera": "^7.0.0",
    "@capacitor/core": "^7.0.0",
    "@capacitor/haptics": "^7.0.0",
    "@capacitor/ios": "^7.0.0",
    "@capacitor/keyboard": "^7.0.0",
    "@capacitor/preferences": "^7.0.0",
    "@capacitor/splash-screen": "^7.0.0",
    "@capacitor/status-bar": "^7.0.0",
    "@capawesome/capacitor-android-edge-to-edge-support": "^7.2.3",
    "@datorama/akita": "^8.0.1",
    "@datorama/akita-ngdevtools": "^7.0.0",
    "@floating-ui/dom": "^1.7.5",
    "@flowww/design-system": "2.3.17",
    "@flowww/signaturepad": "^4.0.0",
    "@flowww/wizard": "3.15.0",
    "@ionic/angular": "^8.0.0",
    "@ionic/core": "^8.0.0",
    "@ngx-translate/core": "^14.0.0",
    "@ngx-translate/http-loader": "^7.0.0",
    "@pqina/angular-pintura": "^8.57.9",
    "@pqina/pintura": "^8.94.3",
    "@types/luxon": "^3.3.7",
    "color": "^4.2.3",
    "crypto-js": "^4.1.1",
    "ionicons": "^7.0.0",
    "jspdf": "^3.0.1",
    "lodash.deburr": "^4.1.0",
    "luxon": "^3.0.4",
    "moment": "^2.29.4",
    "ngx-extended-pdf-viewer": "^24.2.4",
    "rxjs": "^7.4.0",
    "signature_pad": "^2.3.2",
    "swiper": "^9.4.1",
    "timers": "^0.1.1",
    "tslib": "^2.5.3",
    "uuid": "^9.0.0",
    "xml2js": "0.6.2",
    "zone.js": "^0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "20.1.4",
    "@angular-eslint/builder": "15.2.1",
    "@angular-eslint/eslint-plugin": "15.2.1",
    "@angular-eslint/eslint-plugin-template": "15.2.1",
    "@angular-eslint/template-parser": "15.2.1",
    "@angular/cli": "20.1.4",
    "@angular/compiler": "20.1.4",
    "@angular/compiler-cli": "20.1.4",
    "@angular/language-service": "20.1.4",
    "@capacitor/assets": "^3.0.5",
    "@capacitor/cli": "6.0.0",
    "@ionic/angular-toolkit": "11.0.0",
    "@types/jasmine": "~4.3.2",
    "@types/jasminewd2": "~2.0.10",
    "@types/lodash.deburr": "4.1.7",
    "@types/node": "20.2.5",
    "@types/signature_pad": "4.0.0",
    "@types/xml2js": "^0.4.11",
    "@typescript-eslint/eslint-plugin": "5.59.8",
    "@typescript-eslint/parser": "5.59.8",
    "eslint": "^8.42.0",
    "eslint-plugin-import": "2.27.5",
    "eslint-plugin-jsdoc": "46.2.4",
    "eslint-plugin-prefer-arrow": "1.2.3",
    "jasmine-core": "~5.0.0",
    "jasmine-spec-reporter": "~7.0.0",
    "karma": "~6.4.2",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-coverage-istanbul-reporter": "~3.0.3",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "^2.1.0",
    "typescript": "^5.4.5"
  },
  "description": "Mobile version of Flowww management software.",
  "prettier": {
    "singleQuote": true,
    "tabWidth": 4
  },
  "overrides": {
    "xml2js": "0.6.2",
    "sax": "1.4.1",
    "@datorama/akita": {
      "tslib": "^2.8.1"
    }
  }
}
